<div class="vertical-nav-bar">
  <div class="nav-item" (click)="changeSection('inventory')">
    <mat-icon class="nav-icons">inventory_2</mat-icon>
    <span class="nav-item-label">Inventory</span>
  </div>
  <div
    class="nav-item"
    (click)="changeSection('transfer')"
    *ifPermissions="['Engage Transfer', 'Engage Support', 'Internal Admin']"
  >
    <mat-icon class="nav-icons">sync_alt</mat-icon>
    <span class="nav-item-label" *ifPermissions="['Engage Transfer']"
      >Transfer Licenses</span
    >
    <span
      class="nav-item-label"
      *ifPermissions="['Engage Support', 'Internal Admin']"
      >Generate Licenses</span
    >
  </div>
  <div class="nav-item" (click)="changeSection('history')">
    <mat-icon class="nav-icons">pending_actions</mat-icon>
    <span class="nav-item-label">History</span>
  </div>
</div>
